export default "__VITE_ASSET__BXuDAed4__"